// (function ($) {
//   'use strict';

//   if (!$.tangible) {
//     $.tangible = new Object();
//   };

//   $.tangible.funnelSmoothScroll = function (el, options) {
//     var base = this;

//     base.$el = $(el);
//     base.el = el;

//     base.init = function () {

//       base.$window = $(window);
//       base.$scrollTarget = $('.js-autoscroll-point');
//       base.$cartMinimalH = $('.c-cart__minimal').outerHeight();

//       base.checkWidth = function () {
//         var windowsize = base.$window.width();
//         if (windowsize < 1024 ) {
//           base.scrollToDivMobile();
//         } else {
//           base.scrollToDivDesktop();
//         }
//       }

//       base.scrollToDivDesktop = function () {
//         setTimeout(function () {
//           $('html, body').animate({
//             scrollTop: base.$scrollTarget.offset().top - 16
//           }, 2000);
//         }, 500);
//       };

//       base.scrollToDivMobile = function () {
//         setTimeout(function () {
//           $('html, body').animate({
//             scrollTop: base.$scrollTarget.offset().top - base.$cartMinimalH - 16
//           }, 2000);
//         }, 500);
//       };

//       base.checkWidth();

//     };

//     base.init();

//   };

//   $.fn.tangible_funnelSmoothScroll = function (options) {
//     return this.each(function () {
//       (new $.tangible.funnelSmoothScroll(this, options));
//     });
//   };

// })(jQuery);
